// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../views/modules/content-and-icons/assets/scss/content-and-icons.scss
// module id = 55
// module chunks = 35